import React, { useMemo } from "react";
import GenericTableFilter from "../../../components/common/GenericTableFilter";

const DealerStockReportFilters = ({
  filterFields,
  columns,
  customFilterTypes,
  customFilterOptions,
  handleSearch,
  handleApplyFilters,
  handleResetFilters,
  handleFilterChange
}) => {
  const initialFilters = useMemo(() => {
    const f = {};
    (filterFields || []).forEach(ff => (f[ff.field] = ""));
    return f;
  }, [filterFields]);

  return (
    <GenericTableFilter
      data-open-filter="1"
      filterFields={filterFields}
      columns={columns}
      initialFilters={initialFilters}
      onSearch={handleSearch}
      onApplyFilters={handleApplyFilters}
      onResetFilters={handleResetFilters}
      onChange={handleFilterChange}
      customFilterTypes={customFilterTypes}
      customFilterOptions={customFilterOptions}
    />
  );
};

export default DealerStockReportFilters;
